import type { SVGProps } from "react";
const ShoppingCartPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <path
      d="M1.875 9.375C2.20652 9.375 2.52446 9.5067 2.75888 9.74112C2.9933 9.97554 3.125 10.2935 3.125 10.625C3.125 10.9565 2.9933 11.2745 2.75888 11.5089C2.52446 11.7433 2.20652 11.875 1.875 11.875C1.54348 11.875 1.22554 11.7433 0.991116 11.5089C0.756696 11.2745 0.625 10.9565 0.625 10.625C0.625 10.2935 0.756696 9.97554 0.991116 9.74112C1.22554 9.5067 1.54348 9.375 1.875 9.375ZM1.875 9.375H8.75M1.875 9.375V0.625H0.625M8.75 9.375C9.08152 9.375 9.39946 9.5067 9.63388 9.74112C9.8683 9.97554 10 10.2935 10 10.625C10 10.9565 9.8683 11.2745 9.63388 11.5089C9.39946 11.7433 9.08152 11.875 8.75 11.875C8.41848 11.875 8.10054 11.7433 7.86612 11.5089C7.6317 11.2745 7.5 10.9565 7.5 10.625C7.5 10.2935 7.6317 9.97554 7.86612 9.74112C8.10054 9.5067 8.41848 9.375 8.75 9.375ZM1.875 1.875L5.625 2.14312M10.0862 6.25125L9.99687 6.87625H1.87187M7.5 2.5H11.25M9.375 0.625V4.375"
      stroke="white"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ShoppingCartPlus;
